import freeze from '.Object.freeze';

export default          class Node {
	
	          constructor () { return this; }
	
	get [Symbol.toStringTag] () { return 'SFC.Template.Content.*.Node'; }
	
	         firstChild                        = null;
	         nextSibling                        = null;
	afterAppend (                         refChild                       , newChild                ) {
		return refChild
			? ( refChild        ).nextSibling = newChild
			: ( this        ).firstChild = newChild;
	}
	
	                                                                       
	                                                                
	
};

freeze(freeze(Node).prototype);

                                     
                               
                              